import { CheckIcon } from '@heroicons/react/24/solid';
import React from 'react';

export interface WizardStepDefinition {
  id: string;
  title: string;
  description?: string;
}

interface WizardStepsProps {
  steps: WizardStepDefinition[];
  currentStep: number;
  completedSteps: Set<number>;
}

export const WizardSteps: React.FC<WizardStepsProps> = ({
  steps,
  currentStep,
  completedSteps,
}) => {
  return (
    <nav aria-label="Progress" className="mb-4">
      <ol className="flex items-center justify-center space-x-2">
        {steps.map((step, index) => {
          const isCompleted = completedSteps.has(index);
          const isCurrent = index === currentStep;

          return (
            <li key={step.id} className="flex items-center">
              <div
                className={`
                  flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium
                  ${
                    isCompleted
                      ? 'bg-blue-600 text-white'
                      : isCurrent
                        ? 'bg-blue-100 text-blue-600'
                        : 'bg-gray-100 text-gray-400'
                  }
                `}
              >
                {isCompleted ? (
                  <CheckIcon className="h-3 w-3" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`
                    w-4 h-px mx-1
                    ${isCompleted ? 'bg-blue-600' : 'bg-gray-200'}
                  `}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
